import React, { useState } from "react";
import { XMarkIcon, CameraIcon } from "@heroicons/react/24/outline";
import { generateFullImageUrl } from "../../utilities/utils";
import { useLocation } from "react-router-dom";
import imageCompression from "browser-image-compression";

const ProfileUpload = ({
  classes,
  formik,
  imageUrl,
  setIsChange,
  handleDelete,
  handleProfileChange,
}) => {
  const [isDelete, setIsDelete] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageName, setImageName] = useState("");
  const location = useLocation();
  const updateLocation = location?.pathname.includes("settings");

  const isMobile =
    window.matchMedia &&
    window.matchMedia("only screen and (max-width: 767px)").matches;

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        // Options for image compression
        const options = {
          maxSizeMB: 1, // Maximum size in MB
          maxWidthOrHeight: 500, // Max width or height
          useWebWorker: true, // Use a web worker for faster compression
        };

        // Compress the image
        const compressedFile = await imageCompression(file, options);

        // Update formik with the compressed image
        formik && formik.setFieldValue("profile_photo", compressedFile);
        setSelectedImage(URL.createObjectURL(compressedFile));
        setImageName(compressedFile.name);
        setIsChange && setIsChange(true);
        setIsDelete(false);
        handleProfileChange && handleProfileChange(compressedFile);
      } catch (error) {
        console.error("Image compression error:", error);
      }
    }
  };

  const handleDrop = async (event) => {
    event.preventDefault();
    const files = event.dataTransfer.files;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file) {
        try {
          const compressedFile = await imageCompression(file, {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
          });

          formik && formik.setFieldValue("profile_photo", compressedFile);
          setSelectedImage(URL.createObjectURL(compressedFile));
          setImageName(compressedFile.name);
          setIsChange && setIsChange(true);
          setIsDelete(false);
          handleProfileChange && handleProfileChange(compressedFile);
        } catch (error) {
          console.error("Image compression error:", error);
        }
      }
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const getImage = () => {
    if (selectedImage) {
      return selectedImage;
    } else {
      if (imageUrl) {
        return generateFullImageUrl(imageUrl);
      } else {
        return selectedImage;
      }
    }
  };

  return (
    <>
      {(selectedImage || imageUrl) && !isDelete ? (
        <div className={`${classes}`}>
          {!updateLocation && (
            <label
              htmlFor="cover-photo"
              className="block text-xs font-bold leading-[160%] text-[#869099] uppercase mb-[18px]"
            >
              Upload a photo of yourself
            </label>
          )}
          <div
            className={`${
              updateLocation ? "mt-0 relative" : "mt-2"
            } flex items-center gap-x-[18px]`}
          >
            <img
              src={getImage()}
              alt="Uploaded"
              className={` ${
                updateLocation ? "h-[100px] w-[100px]" : "h-[109px] w-[109px]"
              } rounded-[50%] object-cover`}
            />
            {updateLocation && (
              <div className="absolute -bottom-[5px] right-[5px]">
                <label
                  htmlFor="file-upload"
                  className="h-8 w-8 text-[#ffffff] bg-[#4B5563] rounded-full p-1 cursor-pointer block"
                >
                  <CameraIcon />
                </label>
                <input
                  id="file-upload"
                  type="file"
                  onChange={handleImageUpload}
                  className="hidden"
                />
              </div>
            )}
            {!updateLocation && (
              <div>
                <label className="text-base font-medium leading-[160%] text-customGray mb-1">
                  {imageName}
                </label>
                <div
                  className="flex items-center gap-[3px]"
                  onClick={handleDelete && handleDelete}
                >
                  <XMarkIcon
                    className="h-[18px] w-[18px] text-[#EF2121] cursor-pointer"
                    onClick={() => {
                      setSelectedImage(null);
                      setImageName("");
                      setIsChange && setIsChange(true);
                      setIsDelete(true);
                      formik && formik.setFieldValue("profile_photo", null);
                    }}
                  />
                  <label
                    className="text-[#EF2121] text-sm font-bold leading-[160%] cursor-pointer"
                    onClick={() => {
                      setSelectedImage(null);
                      setImageName("");
                      setIsChange && setIsChange(true);
                      setIsDelete(true);
                      formik && formik.setFieldValue("profile_photo", null);
                    }}
                  >
                    Delete
                  </label>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className={`${classes}`}>
          <label
            htmlFor="cover-photo"
            className={`block text-xs font-bold leading-[160%] text-[#869099] uppercase ${
              updateLocation ? "mb-2" : "mb-4"
            }`}
          >
            Upload a photo of yourself
          </label>
          <div
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            className={`flex justify-center rounded-[10px] bg-[#EBF7FF] border border-dashed border-primary px-5 ${
              updateLocation ? "py-4" : "py-[30px]"
            }`}
          >
            <div className="text-center">
              <div className="flex text-sm leading-6 text-gray-600">
                <p className="text-sm font-medium leading-[160%] text-customGray mb-[5px]">
                  {!isMobile && "Drag and Drop or "}
                  <label
                    htmlFor="file-upload"
                    className="relative cursor-pointer underline text-primary"
                  >
                    <span>Choose Photo</span>
                    <input
                      id="file-upload"
                      name="file-upload"
                      type="file"
                      onChange={handleImageUpload}
                      className="sr-only"
                    />
                  </label>{" "}
                  of Yourself to Upload
                </p>
              </div>
              <p className="text-sm leading-[160%] text-[#485868]">
                Maximum File Size 10 MB
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProfileUpload;
